import { lazy } from 'react';

// Search queries:
export const SearchQueryToggle = lazy(() => import('./SearchQueryToggle'));
export const SearchQueryPhrase = lazy(() => import('./SearchQueryPhrase'));
export const SearchQueryFilter = lazy(() => import('./SearchQueryFilter'));
